// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lwXP_","col":"styles_col__149XI"};